import { render, staticRenderFns } from "./DocumentTemplateSections.vue?vue&type=template&id=76c96b62&"
import script from "./DocumentTemplateSections.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateSections.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplateSections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports